import {
  VuexModule,
  Module,
  Mutation,
  Action
} from 'vuex-module-decorators'
import { PackageType } from '@/types/global'

export type TicketFormState = {
  packageNumber?: string
  packageType?: PackageType
  subject?: string
  description?: string
  tag?: string
}

@Module({ name: 'TicketForm', namespaced: true })
export default class TicketForm extends VuexModule implements TicketFormState {
  // ➊ State

  private ticketFormState: TicketFormState = {
    packageNumber: undefined,
    packageType: undefined,
    subject: undefined,
    description: undefined,
    tag: undefined
  }

  // ➋ Getters

  public get packageNumber(): string | undefined {
    return this.ticketFormState.packageNumber
  }

  public get packageType(): PackageType | undefined {
    return this.ticketFormState.packageType
  }

  public get subject(): string | undefined {
    return this.ticketFormState.subject
  }

  public get description(): string | undefined {
    return this.ticketFormState.description
  }

  public get tag(): string | undefined {
    return this.ticketFormState.tag
  }

  // ➌ Mutations

  @Mutation
  public SET_PACKAGE_NUMBER(data: string) {
    this.ticketFormState.packageNumber = data
  }

  @Mutation
  public SET_PACKAGE_TYPE(data: PackageType) {
    this.ticketFormState.packageType = data
  }

  @Mutation
  public SET_SUBJECT(data: string) {
    this.ticketFormState.subject = data
  }

  @Mutation
  public SET_DESCRIPTION(data: string) {
    this.ticketFormState.description = data
  }

  @Mutation
  public SET_TAG(data: string) {
    this.ticketFormState.tag = data
  }

  // ➍ Actions
  @Action
  public resetState() {
    this.context.commit('SET_PACKAGE_NUMBER', undefined)
    this.context.commit('SET_PACKAGE_TYPE', undefined)
    this.context.commit('SET_SUBJECT', undefined)
    this.context.commit('SET_DESCRIPTION', undefined)
    this.context.commit('SET_TAG', undefined)
  }
}
